import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/44ce623e-3b9f-41cb-8cf5-dd23ec5b9b65";
export const REGISTER_URL = "https://a.ntrk2.com/91907fbe-91fb-4dfe-a6dd-eb91321f5c54";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://wtfwin.loadprkw2a.com/download?openExternalBrowser=1&id=vspb7a7fughbp9e";
